import { useNavigate, useParams } from 'react-router-dom';

import config from '../../../../config/config';

import RegisterGoogleCompanyPage from '../company/google-form';
import RegisterGooglePersonPage from '../person/google-form';

export default function TypeSelectGoogle() {
  const params = useParams();
  const navigate = useNavigate();
  const { USERS_TYPES } = config;

  if (!USERS_TYPES.includes(params.type || '')) {
    navigate('/');
  }

  return (
    <>
      {params.type === 'company' ? <RegisterGoogleCompanyPage /> : <RegisterGooglePersonPage />}
    </>
  );
}
